import {Injectable, Pipe, PipeTransform} from '@angular/core';

@Pipe({ name: 'mathAbs' })
export class MathAbsPipe implements PipeTransform {
	transform(value: any): any {
		return Math.abs(value)
	}

}



// WEBPACK FOOTER //
// ./src/app/ui-helper/math-abs.pipe.ts